module.exports = __webpack_public_path__ + "main/images/shared/app-store-lock-up.3fa0d88b8b6a72474faca1829231271e.svg";